<div class="empty-state-container">
  <div class="empty-state-content">
    <div class="empty-icon-wrapper">
      <mat-icon class="empty-icon">{{ icon }}</mat-icon>
    </div>
    
    <h2 class="empty-title">{{ title }}</h2>
    <p class="empty-message">{{ message }}</p>
    
    @if (showAction && actionLabel) {
      <div class="empty-actions">
        <button mat-raised-button color="primary" class="action-button">
          {{ actionLabel }}
        </button>
      </div>
    }
  </div>
</div>
